<template>
    <div class="modal fade" id="m_modal_imports" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" v-if="importType">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{ labels[triggers[importType].subtitle1] }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form id="uploadFile" class="fileUploader">

                    <div class="modal-body">
                        <!--<h5>{{ labels[triggers[importType].subtitle1] }}</h5>-->

                        <div class="row">
                            <div class="col-lg-2"></div>
                            <div class="col-lg-8 form-group m-form__group row">
                                <input type="file" id="m-filepond" class="btn btn-info" enctype="text/csv" name="file"/>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="reset" class="btn btn-secondary" data-dismiss="modal" @click="resetInput">{{ labels['cancel'] }}</button>
                        <button type="button" class="btn btn-primary" @click="sendImport" data-dismiss="modal">{{ labels[triggers[importType].buttonText] }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { HTTP } from '../../assets/js/axiosConfig'
import SweetAlert from '../../assets/js/mixins'

const timer = 3000

export default {
    mixins: [SweetAlert],
    data () {
        return {
            // Object of trigger values and their redirect urls, message-text, etc
            triggers: {
                products: {
                    url: '/api/imports/products',
                    title: 'import_product',
                    subtitle1: 'product_upload_helper_text',
                    buttonText: 'submit',
                    savedText: 'products_saved'
                },
                productComplex: {
                    url: '/api/imports/complex/products',
                    title: 'import_product',
                    subtitle1: 'product_upload_helper_text',
                    buttonText: 'submit',
                    savedText: 'products_saved'
                },
                stocks: {
                    url: 'api/imports/stocks',
                    title: 'import_stocks',
                    subtitle1: 'stock_upload_helper_text',
                    buttonText: 'submit',
                    savedText: 'stocks_saved'
                },
                productSPFs: {
                    url: 'api/imports/products/spf',
                    title: 'import_product_spfs',
                    subtitle1: 'spf_upload_helper_text',
                    buttonText: 'submit',
                    savedText: 'spfs_saved'
                }
            },
            fileBlob: null,
            fileAdded: false
        }
    },
    computed: {
        ...mapState([
            'labels',
            'importType'
        ]),
        searchValue: {
            get () {
                return this.search
            },
            set (value) {
                this.search = value
                // Send search request
                if (value) {
                    this.searchForProduct(value)
                }
            }
        }
    },
    methods: {
        ...mapActions([
            'updateImportType'
        ]),
        sendImport () {
            let text = this.triggers[this.importType].savedText
            HTTP.defaults.headers.common = { ['Content-Type'] : 'text/csv' }
            let formData = new FormData(uploadFile)
            var route = this.triggers[this.importType].url
            HTTP.post(route, formData)
                .then(() => {
                    // Alert on success
                    this.sweetAlert('success', this.labels[text], timer)
                    // Clear import type
                    this.updateImportType('')
                })
                .catch(() => this.sweetAlert('error', this.labels['error_adding_product'], timer))
        },
        resetInput () {
            document.getElementById('m-filepond').value = ''
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/ModalImport.vue